/** 仅清理分享链接的微信身份参数，保留业务参数及其原始编码。 */
export const sanitizeShareUrl = (url: string = ''): string => url.split('#').map(part => {
  const queryIndex = part.indexOf('?')
  if (queryIndex < 0) return part

  const query = part.slice(queryIndex + 1)
  const params = query.split('&').reduce<string[]>((result, param) => {
    const equalIndex = param.indexOf('=')
    const rawKey = equalIndex < 0 ? param : param.slice(0, equalIndex)
    let key = rawKey
    try {
      key = decodeURIComponent(rawKey)
    } catch (error) { }
    if (/^(openid|gopenid)$/i.test(key)) return result

    // 活动分享可能先包装为小程序路径，再通过 jumpH5Page 携带 H5 链接。
    if (key === 'jumpH5Page' && equalIndex >= 0) {
      try {
        const nestedUrl = decodeURIComponent(param.slice(equalIndex + 1))
        const sanitized = sanitizeShareUrl(nestedUrl)
        if (sanitized !== nestedUrl) {
          param = `${rawKey}=${encodeURIComponent(sanitized)}`
        }
      } catch (error) { }
    }
    result.push(param)
    return result
  }, []).join('&')

  if (params === query) return part
  return part.slice(0, queryIndex) + (params ? `?${params}` : '')
}).join('#')
